const apps = [
  {
    tag: 'For Food Lovers',
    title: ' FOOD APP',
    tagline: 'Order. Track. Earn.',
    description:
      'Browse thousands of dishes from top restaurants in your city. Place an order in seconds, pay securely, and track your rider live. Every order earns you Sweetplate Coins to redeem later.',
    features: ['Browse 500+ restaurants', 'Real-time delivery tracking', 'Earn SPC tokens every order', 'In-app wallet & payments'],
    cta: 'Download FOOD APP',
    ctaHref: 'https://play.google.com/store/apps/details?id=com.sweetplate.user',
    image:
      'https://readdy.ai/api/search-image?query=happy%20young%20african%20woman%20using%20food%20delivery%20smartphone%20app%20browsing%20restaurant%20menu%20smiling%20satisfied%20modern%20bright%20kitchen%20background%20lifestyle%20photography%20natural%20light&width=600&height=700&seq=app001&orientation=portrait',
    gradient: 'from-[#E6F7F4] to-[#CCEFE9]',
    accent: 'bg-[#009E81]',
    tagBg: 'bg-[#009E81]/10 text-[#009E81]',
    iconColor: 'text-[#009E81]',
  },
  {
    tag: 'For Restaurant Owners',
    title: 'Vendor App',
    tagline: 'Manage. Sell. Grow.',
    description:
      'Register your restaurant and start receiving orders immediately. Manage your menu, pricing, and availability in real-time. Access detailed analytics to grow your business.',
    features: ['Instant order notifications', 'Menu & pricing management', 'Revenue analytics dashboard', 'Rider coordination tools'],
    cta: 'Register as Vendor',
    ctaHref: 'https://merchant.sweetplate.org/',
    image:
      'https://readdy.ai/api/search-image?query=confident%20restaurant%20owner%20chef%20looking%20at%20tablet%20managing%20orders%20digital%20restaurant%20management%20app%20kitchen%20background%20apron%20professional%20african%20male%20business%20owner%20happy&width=600&height=700&seq=app002&orientation=portrait',
    gradient: 'from-[#FFF8E6] to-[#FFF0C2]',
    accent: 'bg-[#D4970B]',
    tagBg: 'bg-[#FFCD1A]/20 text-[#A07000]',
    iconColor: 'text-[#D4970B]',
  },
  {
    tag: 'For Delivery Riders',
    title: 'Rider App',
    tagline: 'Ride. Deliver. Earn.',
    description:
      'Set your own schedule and earn money on your terms. Accept nearby deliveries, navigate with turn-by-turn GPS, and get paid fast. The more you ride, the more you earn.',
    features: ['Flexible hours — work when you want', 'GPS navigation built in', 'Instant earnings payout', 'Rider community & support'],
    cta: 'Become a Rider',
    ctaHref: 'https://sweetplate.org/sweetplateDriver.apk',
    image:
      'https://readdy.ai/api/search-image?query=smiling%20african%20male%20delivery%20rider%20on%20motorcycle%20with%20delivery%20bag%20wearing%20helmet%20looking%20at%20smartphone%20GPS%20navigation%20happy%20confident%20outdoors%20city%20background%20lifestyle%20photography&width=600&height=700&seq=app003&orientation=portrait',
    gradient: 'from-[#FFF1EC] to-[#FFE5D9]',
    accent: 'bg-[#FF7B54]',
    tagBg: 'bg-[#FF7B54]/10 text-[#D94F25]',
    iconColor: 'text-[#FF7B54]',
  },
];

export default function AppEcosystem() {
  return (
    <section className="bg-[#FAFAFA] py-16 md:py-24 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-16">
          <span className="inline-block bg-[#FFF8E6] text-[#D4970B] text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            The Platform
          </span>
          <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 leading-tight">
            One platform. Three powerful apps.
          </h2>
          <p className="mt-4 text-gray-500 text-base md:text-lg max-w-xl mx-auto">
            Whether you&apos;re hungry, running a restaurant, or riding for income — Sweetplate has an app built just for you.
          </p>
        </div>

        <div className="flex flex-col gap-8 md:gap-10">
          {apps.map((app) => (
            <div
              key={app.title}
              className={`rounded-3xl overflow-hidden bg-gradient-to-br ${app.gradient} flex flex-col md:flex-row items-stretch`}
            >
              {/* Image */}
              <div className="w-full h-52 sm:h-64 md:w-64 md:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={app.image}
                  alt={app.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Content */}
              <div className="flex-1 flex flex-col justify-center px-6 py-7 md:px-12 md:py-10 gap-4 md:gap-5">
                <span className={`inline-flex w-fit text-xs font-bold px-3 py-1 rounded-full ${app.tagBg}`}>
                  {app.tag}
                </span>
                <div>
                  <h3 className="text-2xl md:text-4xl font-extrabold text-gray-900">{app.title}</h3>
                  <p className={`text-base md:text-lg font-bold mt-1 ${app.iconColor}`}>{app.tagline}</p>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">{app.description}</p>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                  {app.features.map((feat) => (
                    <li key={feat} className="flex items-center gap-2 text-sm text-gray-700">
                      <span className={`w-5 h-5 flex items-center justify-center rounded-full ${app.accent} flex-shrink-0`}>
                        <i className="ri-check-line text-white text-xs" />
                      </span>
                      {feat}
                    </li>
                  ))}
                </ul>
                <a
                  href={app.ctaHref}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`inline-flex items-center gap-2 w-fit ${app.accent} text-white text-sm font-bold px-6 py-3 rounded-full hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap mt-1`}
                >
                  {app.cta}
                  <i className="ri-arrow-right-line" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
